module.exports = __webpack_public_path__ + "img/loginLogo.74109804.jpg";